import backendRedirect from '../../backendRedirect'

const serverRoot = '/api'
const serverUrl = backendRedirect.apiTrafficManager + serverRoot
const visualizerUrl = '/visualizer/api/visualize'

//const visualizerUrl = '/visualize'

const talmudServerUrl = 'https://talmudsearch.dicta.org.il/api/search'
const tanachSearchServerUrl = 'https://search.dicta.org.il/api/search'

export const StoreConfig = {
  preTokenize: false,
  serverRoot: serverRoot,
  serverUrl: serverUrl,
  visualizerUrl: visualizerUrl,
  talmudServerUrl: talmudServerUrl,
  tanachSearchServerUrl: tanachSearchServerUrl
}
